import { render, staticRenderFns } from "./HeroBannerText.vue?vue&type=template&id=4ec97e3b&scoped=true&lang=pug&"
import script from "./HeroBannerText.vue?vue&type=script&lang=js&"
export * from "./HeroBannerText.vue?vue&type=script&lang=js&"
import style0 from "./HeroBannerText.vue?vue&type=style&index=0&id=4ec97e3b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec97e3b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ec97e3b')) {
      api.createRecord('4ec97e3b', component.options)
    } else {
      api.reload('4ec97e3b', component.options)
    }
    module.hot.accept("./HeroBannerText.vue?vue&type=template&id=4ec97e3b&scoped=true&lang=pug&", function () {
      api.rerender('4ec97e3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/HeroBannerText.vue"
export default component.exports